import React, { Component } from 'react';
// import { DatePicker, } from 'antd';
import OrderTable from './orderTable';

const clsPrefix = 'order';
// const { RangePicker } = DatePicker;

// function onChange(date, dateString) {
//     console.log(date, dateString);
// }
  
class OrderDetails extends Component {
    render(){
        return(
            <div className={clsPrefix}>
                {/* <div className={`${clsPrefix}-select`}>
                    <span className={`${clsPrefix}-selectTitle ${clsPrefix}-time`}>时间</span><RangePicker onChange={onChange} />
                </div> */}
                <div className={`${clsPrefix}-table`}>
                    <OrderTable />
                </div>
            </div>                     
        );
    }
}
export default OrderDetails;